import * as yup from 'yup';
export const CreateJudgeFormValidation = yup.object().shape({
    idUser:yup.string().optional(),
    user: yup.object().shape({
      name: yup.string().required('Nome é obrigatório'),
      userName: yup.string().required('Nome de utilizador é obrigatório'),
      email: yup.string().email('Email inválido').required('Email é obrigatório'),
      bi: yup.string().required('BI é obrigatório'),
      nuit: yup.string().required('Nuit é obrigatório').matches(/^\d{9}$/, 'Deve ter 9 dígitos'),
      phoneNumber: yup.string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, 'Número de telemóvel inválido')
      .required('Número de telemóvel é obrigatório'),
      secondaryPhoneNumber: yup.string()
      .matches(/^(82|83|84|85|86|87)\d{7}$/, 'Número de telemóvel inválido')
      .optional(),
      dateOfBirth: yup.string().required('Data de nascimento é obrigatória')
        .test('is-date', 'Data inválida', (value) => !value || !isNaN(Date.parse(value)))
        .test('is-past', 'Data de nascimento não pode ser no futuro', (value) => !value || new Date(value) <= new Date()),
      gender: yup.string().oneOf(['M', 'F'], 'Gênero inválido').default('M').required('Gênero é obrigatório'),
    }).required(), 
  });
  